<template>
  <modal-template :title="$t('buyerInfo.introduceTusDatos')"
                  class="modal-height"
                  size="intermedium"
                  close-position="left"
                  @close="$root.$emit('closeBuyerInfoNoCreate')">
    <div class="posR">
      <div class="container-onboarding container-buyer-info">
        <b-row>
          <b-col v-if="user.id"
                 cols="12"
                 class="tAc">
            <p>{{ $t('buyerInfo.hemosDetectadoQueEresUsuarioDeWegow') }}</p>
            <b-button class="topaz"
                      @click="continueAs()">{{ $t('buyerInfo.continuaComo', { first_name: user.first_name }) }}</b-button>
          </b-col>
          <b-col v-if="user.id"
                 cols="12">
            <span class="or-line"> {{ $t('signup.o') }}</span>
          </b-col>
          <b-col cols="12">
            <validation-observer v-slot="{ invalid }">
              <b-form @submit.prevent="buyerInfo">
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input v-model="model.first_name"
                                  type="text"
                                  required
                                  :placeholder="$t('basicInfoPurchase.nombre')"
                                  name="first_name"
                                  :class="{'error': errors[0]}" />
                  </b-form-group>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group>
                    <b-form-input v-model="model.last_name"
                                  type="text"
                                  required
                                  :placeholder="$t('basicInfoPurchase.apellido')"
                                  name="last_name"
                                  :class="{'error': errors[0]}" />
                  </b-form-group>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     rules="required|email|confirmed:emailConfirmation">
                  <fieldset class="form-group">
                    <input id="emailSignup"
                           v-model="model.email"
                           name="email"
                           :placeholder="$t('signup.email')"
                           :class="{'error': errors[0]}"
                           type="email" />
                  </fieldset>
                </validation-provider>
                <validation-provider v-slot="{ errors }"
                                     vid="emailConfirmation"
                                     rules="required|email">
                  <fieldset class="form-group">
                    <input id="emailConfirmationSignup"
                           v-model="model.emailConfirmation"
                           name="email-confirmation"
                           :placeholder="$t('signup.emailConfirmation')"
                           :class="{'error': errors[0]}"
                           autocomplete="off"
                           onpaste="return false"
                           onCopy="return false"
                           onCut="return false"
                    />
                  </fieldset>
                </validation-provider>
                <b-form-group>
                  <validation-provider v-slot="{ errors }"
                                       rules="required">
                    <input ref="autocomplete"
                           :placeholder="$t('userProfileOnboarding.localizacion')"
                           :class="{'error': errors[0]}"
                           class="search-location form-control"
                           name="location"
                           type="text">
                  </validation-provider>
                </b-form-group>
                <b-form-row class="mB1rem">
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:2|max:2">
                      <b-form-input v-model="day"
                                    placeholder="DD"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="day"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4"
                         class="pR10">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:2|max:2">
                      <b-form-input v-model="month"
                                    placeholder="MM"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="month"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                  <b-col cols="4">
                    <validation-provider v-slot="{ errors }"
                                         rules="required|min:4|max:4">
                      <b-form-input v-model="year"
                                    placeholder="YYYY"
                                    class="tAc"
                                    :class="{'error': errors[0] || birthdayError}"
                                    type="text"
                                    name="year"
                                    @input="fillBirthday" />
                    </validation-provider>
                  </b-col>
                </b-form-row>
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-form-group id="termsAcceptedCheckboxGroup">
                    <b-form-checkbox id="termsAcceptedCheckbox"
                                     v-model="model.privacy_policy"
                                     name="terms"
                                     required
                                     :class="{'error': errors[0]}">
                      <span v-html="$t('signup.aceptoLosTerminosYCondicionesYLaPoliticaDePrivacidad', {terms_and_conditions: 'https://www.wegow.com/es-es/terminos-y-condiciones/', privacy: 'https://www.wegow.com/es-es/aviso-legal/'})" />
                    </b-form-checkbox>
                  </b-form-group>
                </validation-provider>
                <b-form-group id="newsletterCheckboxGroup">
                  <b-form-checkbox id="newsletterCheckbox"
                                   v-model="model.newsletter"> {{ $t('signup.meGustariaRecibirInformacionDeLasNovedadesDeConciertosYFestivalesDeWegow') }}</b-form-checkbox>
                </b-form-group>
                <div class="tAc">
                  <button :disabled="invalid || isDisabled"
                          :class="{'topaz': !invalid && !isDisabled, 'transparent': invalid || isDisabled}"
                          type="submit"
                          class="btn topaz">{{ $t('basicInfoPurchase.continua') }}</button>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
      </div>
    </div>
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </modal-template>
</template>

<script>
import { userStatus } from '@/plugins/mixins/userStatus.js'
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'
import WSwitch from '@/components/wswitch/WSwitch.vue'
import Loader from '@/components/loader/Loader.vue'

export default {
  components: {
    ModalTemplate,
    WSwitch,
    Loader
  },
  mixins: [userStatus],
  data: () => ({
    model: {
      first_name: '',
      last_name: '',
      email: '',
      emailConfirmation: '',
      location: {},
      birthday: '',
      newsletter: false,
      privacy_policy: false
    },
    day: '',
    month: '',
    year: '',
    loading: false,
    birthdayError: false
  }),
  computed: {
    isDisabled() {
      return (
        this.model.first_name === '' ||
        this.model.last_name === '' ||
        this.model.email === '' ||
        this.birthdayError ||
        this.$moment().diff(
          this.$moment(
            this.day + '/' + this.month + '/' + this.year,
            'DD/MM/YYYY'
          ),
          'years'
        ) < 16 ||
        this.model.location.place_id === 'undefined' ||
        !this.model.privacy_policy
      )
    },
    event() {
      return this.$store.state.event.detail
    },
    user() {
      return this.$store.state.user.detail
    }
  },
  mounted() {
    this.autocomplete = new window.google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ['(cities)'] }
    )
    this.autocomplete.addListener('place_changed', () => {
      let place = this.autocomplete.getPlace()
      if (place && place.geometry && place.geometry.location) {
        this.model.location = {
          place_id: place.id,
          longitude: place.geometry.location.lng(),
          latitude: place.geometry.location.lat(),
          name: place.name
        }
      }
    })
  },
  methods: {
    continueAs() {
      var userStatus = this.checkUserStatus()
      if (userStatus === 'name' || userStatus === 'profile') {
        this.$root.$emit('openBasicInfoPurchase')
      } else {
        this.$root.$emit('closeBuyerInfo')
      }
    },
    async buyerInfo() {
      this.loading = true
      await this.$store.dispatch('user/clean')
      await this.$store.dispatch('initial/clean')
      var data = {
        email: this.model.email,
        first_name: this.model.first_name,
        last_name: this.model.last_name,
        newsletter: this.model.newsletter,
        privacy_policy: this.model.privacy_policy,
        birthday: this.$moment(this.model.birthday).format('YYYY-MM-DD'),
        location: this.model.location
      }
      await this.$store.dispatch('buyer/create', data)
      this.$root.$emit('closeBuyerInfo')
      this.loading = false
    },
    fillBirthday() {
      if (this.day && this.month && this.year.length === 4) {
        if (
          this.$moment(
            this.day + '/' + this.month + '/' + this.year,
            'DD/MM/YYYY'
          ).isValid()
        ) {
          if (
            this.$moment().diff(
              this.$moment(
                this.day + '/' + this.month + '/' + this.year,
                'DD/MM/YYYY'
              ),
              'years'
            ) < 16
          ) {
            this.birthdayError = true
          } else {
            this.model.birthday = this.$moment(
              this.day + '/' + this.month + '/' + this.year,
              'DD/MM/YYYY'
            ).toDate()
            this.birthdayError = false
          }
        } else {
          this.birthdayError = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#wegow-default-styles {
  .container-buyer-info {
    input {
      min-width: auto;
    }
  }
}
</style>
